import React, {useContext, useEffect, useState} from 'react';
import {observer} from "mobx-react";
import {StoreContext} from "../../store.context";

type Props = {
    access: {
        routeName: string,
        attributes: Array<{[key: string]: [value: any]}>
    }
    children: React.ReactNode,
    onDenied?: () => void
}

const AccessUtil: React.FC<Props> = observer(({ access, onDenied, children}): any => {
    const {
        appStore: {
            accessStore: {
                hasAccess
            }
        },
    } = useContext(StoreContext);

    const [ loading, setLoading ] = useState<boolean>(true);
    const [accessGranted, setAccessGranted] = useState<boolean>(false);

    useEffect(() => {
        hasAccess(access).then(() => {
            setAccessGranted(true);
        }).catch(() => {
            setAccessGranted(false);
        }).finally(() => {
            setLoading(false);
        })
    }, [hasAccess, access]);

    if (!accessGranted || loading) return (onDenied && onDenied()) ?? null;

    return <>{children}</>;
});

export default AccessUtil;